import { css, type FlattenSimpleInterpolation } from 'styled-components'
import zLayers from '../utils/styling/zLayers'
import { TINYMCE_BASE_FONT_FAMILY } from '@messenger/lotus/fonts'

export const tinyMCEStyles: FlattenSimpleInterpolation = css`
  .mce-content-body {
    font-family: ${TINYMCE_BASE_FONT_FAMILY};
    font-size: 14px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    width: 100%;
    overflow-x: visible;
    margin: 0px;
    line-height: 1;
    padding: 0 2px;
  }
  /* offsets following cursor difficulty and having the wrong size outline on the text box */
  .mce-content-body:focus {
    outline: none;
  }
  .mce-edit-focus {
    outline: none;
  }

  .mce-content-body p {
    margin: 0;
  }

  .tox-tinymce-inline {
    z-index: ${zLayers.interface};
  }

  #obituary .mce-content-body {
    padding: 24px;
    line-height: 18px;
  }

  .mce-case-upper {
    text-transform: uppercase;
  }

  .mce-case-lower {
    text-transform: lowercase;
  }

  .mce-case-capitalize {
    text-transform: capitalize;
  }

  /* Fixed-width toolbar button for customFontSelect with ellipsis on long
   * font names. The stock fontselect button is rendered with the internal
   * .tox-tbtn--bespoke class which the Oxide skin styles as
   * "width: 7em; overflow:hidden; text-overflow:ellipsis". addMenuButton —
   * the public API we register customFontSelect through — does not get the
   * bespoke class, so we replicate the same constraints here, scoped to
   * our button by aria-label so other addMenuButton toolbar buttons in
   * this editor are left alone. See registerCustomFontSelectPlugin.ts.
   */
  /* Prefix-match because registerCustomFontSelectPlugin mutates aria-label
   * to include the active font name ("Fonts - Lato") for the hover tooltip. */
  .tox .tox-tbtn--select[aria-label^='Fonts'] {
    width: 9em;
  }
  .tox .tox-tbtn--select[aria-label^='Fonts'] .tox-tbtn__select-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 7em;
    margin: 0 4px;
  }
`

export default tinyMCEStyles
